
export let listenSolitaireChangeObj = {
  solitaireObj: {
    handler(solitaireObj) {
      this.$store.commit('cgSolitaireObj', solitaireObj)
    },
    deep: true
  }
};
